// enrichedEvents.js — v2 : préchargement en une requête au démarrage

import { supabase } from './supabase';

// Cache global — chargé une seule fois
const cache = new Map();
let loaded  = false;
let loading = false;

// Précharge TOUS les événements enrichis en une seule requête
export async function preloadEnrichedEvents() {
  if (loaded || loading) return;
  loading = true;
  try {
    const { data } = await supabase
      .from('events_enriched')
      .select('*');
    if (data) {
      data.forEach(ev => cache.set(ev.id, ev));
      console.log(`✅ ${data.length} fiches enrichies chargées`);
    }
    loaded = true;
  } catch (e) {
    console.warn('Supabase enrichedEvents:', e.message);
  }
  loading = false;
}

// Récupère depuis le cache — instantané après préchargement
export function getEnrichedEvent(eventId) {
  return cache.get(eventId) || null;
}

// Fallback async si pas encore chargé
export async function getEnrichedEventAsync(eventId) {
  if (!loaded) await preloadEnrichedEvents();
  return cache.get(eventId) || null;
}
